import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { assetData } from "./fragments";

export const ASSET_SAVED = gql`
  subscription assetSaved($documentId: Int!) {
    assetSaved(documentId: $documentId) {
      isNew
      asset {
        ...assetData
      }
      silentMode
      headers {
        ...messageHeaders
      }
    }
  }
  ${assetData}
  ${messageHeaders}
`;

export const ASSET_IMAGE_RETRIEVED = gql`
  subscription assetImageRetrieved {
    assetImageRetrieved {
      imageUrl
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
